import Vue, { computed, getCurrentInstance, ref } from "vue";

export default function useStripe() {
  const $vm = getCurrentInstance()?.proxy;

  const cardElement = ref(undefined);
  const cardElementContainer = ref(undefined);

  const stripe = computed(() => $vm.$store.getters.stripe);
  const stripeKey = Vue.Spark("stripeKey");
  const loadingStripe = computed(() => $vm.$store.getters.loadingStripe);

  function checkStripe() {
    const error = $vm.$t("failed_stripe_credential_message");
    if (!stripe.value) throw new Error(error);
  }

  function createCardElement(container) {
    checkStripe();

    const card = stripe.value.elements().create("card", {
      hideIcon: false,
      hidePostalCode: true,
      style: {
        base: {
          "::placeholder": { color: "#aab7c4" },
          fontFamily: `Whitney, Lato, -apple-system, BlinkMacSystemFont,"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji","Segoe UI Emoji", "Segoe UI Symbol"`,
          color: "#495057",
          fontSize: "15px",
        },
      },
    });

    card.mount(container);

    return card;
  }

  function generateSubscriptionToken() {
    const url = $vm.$apiUrl("settings/subscription/token");
    return axios.get(url);
  }

  function applyPaymentAction(paymentId) {
    window.location = $vm.$buildUrl("/{cashier}/payment/{id}?redirect={uri}", {
      cashier: $vm.$Spark("cashierPath"),
      id: paymentId,
      uri: window.location.origin + $vm.$appUrl("settings/orders"),
    });
  }

  function initializeCardElement() {
    if (
      cardElement.value === undefined &&
      cardElementContainer.value !== undefined
    ) {
      cardElement.value = createCardElement(cardElementContainer.value);
    }
  }

  return {
    cardElement,
    cardElementContainer,

    stripe,
    stripeKey,
    loadingStripe,

    initializeCardElement,
  };
}
